import { get } from "../utils/request";
import { getUserScope }  from './scope';

export const getUserProfile = async () => {
  const result =  await get(`/v1/users/me`);
  // try {}
  // if (result) {
  //   const scope = await getUserScope();
  //   result.scope = scope;
  // }
  return result; 
}